import { memo } from 'react';

import { InlineStyle } from '@/components/ui/utils/inlineStyle/inlineStyle';

type Props = React.ComponentProps<typeof InlineStyle>;

export const InlineStyleWrapper = memo(
  ({ data, rules, children, ...props }: Props) => (
    <InlineStyle className="size-full" data={data} rules={rules} {...props}>
      {children}
    </InlineStyle>
  )
);
